/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeMembers.defs'
export { main as default } from './removeMembers.defs'
